import { Checkbox } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text'
import React, { useState } from 'react'
import TextWithIcon from './TextWithIcon';

function TableRowCard({
    columns = [],
    row = {},
    className = '',
    isSelection = false,
    selectMultiRows,
    removeMultiRows,
    selectedRows = []
}) {

    const [viewMore, setViewMore] = useState(false);
    const itemsToShow = viewMore ? columns.length : 5
    const isAction = columns.filter(item => item.Header === 'Action' || item.Header === 'Actions');

    return (
        <div className={`relative border border-solid border-gray-400 p-3 ${className}`}>
            <div className='grid grid-cols-2 gap-2.5'>
                {
                    columns.slice(0, itemsToShow).map((col, i) => {
                        if (col.Header === 'Action' || col.Header === 'Actions') return null;
                        return (
                            <div className={`flex flex-col gap-0.5 ${col?.cardClass}`}>
                                {!col?.hideHeader && <Text key={i} variant='label' className='text-gray-1100'>{col.Header}</Text>}
                                <div className='flex gap-2'>
                                    {
                                        (isSelection && i === 0) && (
                                            <Checkbox
                                                onChangeHandler={(data) => {
                                                    data.value ? selectMultiRows(row) : removeMultiRows(row);
                                                }}
                                                value={selectedRows.find((item) => (item?.allocationId ? item?.allocationId === row?.original?.allocationId : item?.id === row?.original?.id)) || false}
                                            />
                                        )
                                    }
                                    {
                                        typeof col.accessor === 'function' ?
                                            <div className='flex-1'>{col.accessor(row)}</div>
                                            : <Text key={i} variant='bodySemibold'> {col?.cardTitleShow && col.Header + ':'} {row[col.accessor]}</Text>
                                    }
                                    {
                                        (isAction.length > 0 && !isAction[0]?.showAtBottom && i === 0) && (
                                            isAction[0].accessor(row)
                                        )
                                    }
                                </div>
                            </div>

                        )
                    })
                }
            </div>
            {
                columns.length >= itemsToShow  && (
                    <div className="flex items-end my-3">
                        <TextWithIcon
                            onClick={() => setViewMore(!viewMore)}
                            text={viewMore ? 'View less' : 'View more'}
                            iconClass={`transition-all ${viewMore ? 'rotate-180' : null}`}
                        />
                    </div>
                )
            }
            {
                (isAction.length > 0 && isAction[0]?.showAtBottom) && (
                    <div className='mt-3'>
                        {isAction[0].accessor(row)}
                    </div>
                )
            }
        </div>
    )
};

export default TableRowCard;